import ImageCollectionPage from "../components/ImageCollectionPage";

export default function Profession() {
  return <ImageCollectionPage title="Profession" path="/culture/profession" collection="culture_profession" />;
}
